import * as ReactRedux from 'react-redux';
import {IStore} from '../../redux/session/reducers';
import {selfStatusSelector, peerStatusSelector} from '../../redux/session/selectors';
import {VideoContainer as Container, IVideoContainerConnectedProps} from './video-pane-ui';

const mapStateToProps = (state: IStore): IVideoContainerConnectedProps => ({
  audioOutputDeviceId: state.videoSettings.audioOutputDeviceId,
  audioInputDeviceId: state.videoSettings.audioInputDeviceId,
  videoInputDeviceId: state.videoSettings.videoInputDeviceId,
  videoQualityId: state.videoSettings.videoQualityId,
  isInterviewer: state.session.isInterviewer,
  sessionType: state.sessionRouter.sessionType,
  selfStatus: selfStatusSelector(state),
  peerStatus: peerStatusSelector(state),
  startTime: state.session.startTime,
  token: state.session.token,
});

export const VideoContainer: any = ReactRedux.connect(
  mapStateToProps,
)(Container);
